import { useState, useEffect } from "react";
import Navbar from "../navbar.js";
import Home from "./Home.js";
import About from "./About.js";
import Contact from "./Contact.js";
import Locations from "./Locations.js";
import Merch from "./Merch.js";
import Cart from "./Cart.js";
import Checkout from "./Checkout.js";
import PaymentPage from "./PaymentPage.js";
import SuccessPage from "./SuccessPage.js";

export function Storefront() {
  const clientSecret = localStorage.getItem("clientSecret");
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  //check for all states across all pages for cart and sync with localStorage
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart((prevCart) => [...prevCart, product]);
    localStorage.setItem("cart", JSON.stringify([...cart, product]));
  };

  const removeFromCart = (indexToRemove) => {
    setCart((prevCart) => prevCart.filter((_,index) => index !== indexToRemove));
    const updatedCart = cart.filter((_, index) => index !== indexToRemove);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };
  const clearCart = () => {
    setCart([]);
    localStorage.setItem("cart", JSON.stringify([]));
  }


  let component;

  switch (window.location.pathname) {
    case "/":
      component = <Home />;
      break;
    case "/about":
      component = <About />;
      break;
    case "/contact":
      component = <Contact />;
      break;
    case "/locations":
      component = <Locations />;
      break;
    case "/merch":
      component = <Merch addToCart={addToCart} />;
      break;
    case "/cart":
      component = <Cart cart={cart}
      removeFromCart = {removeFromCart}
      clearCart = {clearCart}
      />;
      break;
    case "/checkout":
      component = <Checkout cart={cart}/>
      break;
    case "/payment":
      component = <PaymentPage clientSecret={clientSecret}/>
      break;
    case "/success":
      component = <SuccessPage setCart={setCart}/>
      break;
    default:
      component = <Home />;
  }

  return (
    <>
      <Navbar/>
      <div className="container">
        {component}
      </div>
    </>
  );
}

export default Storefront;